import React, { type ComponentType, type ReactNode } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import messages from './messages';

export type Props = {
	isEnabled: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	AvatarImage: ComponentType<Record<any, any>>;
	onSelectAvatar: () => void;
};

type PropsWithIntl = Props & {
	intl: IntlShape;
};

export function Avatar({
	AvatarImage,
	intl: { formatMessage },
	onSelectAvatar,
	isEnabled,
}: PropsWithIntl) {
	return (
		<div>
			<AvatarImage />
			<AvatarActionsWrapper>
				<Button isDisabled={!isEnabled} onClick={onSelectAvatar}>
					{formatMessage(messages.selectAvatar)}
				</Button>
			</AvatarActionsWrapper>
		</div>
	);
}

export default injectIntl(Avatar);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AvatarActionsWrapper = styled.div<{
	children?: ReactNode;
}>({
	display: 'flex',
	justifyContent: 'center',
	padding: `${token('space.150', '12px')} 0 ${token('space.050', '4px')}`,
});
